import { FETCH_SMELTER_DATA_FREE } from '../actions';

export default (state = {}, action) => {
	switch (action.type) {
		case FETCH_SMELTER_DATA_FREE:
			return action.payload;
		default:
			return state;
	}
};
